var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-main", attrs: { id: "newYearGifts" } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "banner" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("300001")))]),
          _vm._v(" "),
          _c("div", { staticClass: "banner-title" }, [
            _vm._v(_vm._s(_vm.$t("300002")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "activity-container" }, [
          _c("div", { staticClass: "activity-content" }, [
            _c("p", {
              staticClass: "content",
              domProps: { innerHTML: _vm._s(_vm.$t("300003")) }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "time",
              domProps: { innerHTML: _vm._s(_vm.$t("300004")) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "activity-detail" }, [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("300005")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "block" }, [
              _vm._v("\n          " + _vm._s(_vm.$t("300006")) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "activity-detail" }, [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("300007")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "block" }, [
              _vm._v(_vm._s(_vm.$t("300008")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-title" }, [
              _vm._v(_vm._s(_vm.$t("300025")) + "：")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-1" }, [
              _c("div", { staticClass: "table-column" }, [
                _c("div", { staticClass: "table-row header" }, [
                  _vm._v(_vm._s(_vm.$t("300021")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("500")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("2000")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("5000")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("10000")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("20000")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("50000")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-column" }, [
                _c("div", { staticClass: "table-row header" }, [
                  _vm._v(_vm._s(_vm.$t("300022")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [
                  _vm._v("0.09%/0.10%")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [
                  _vm._v("0.08%/0.10%")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [
                  _vm._v("0.07%/0.10%")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [
                  _vm._v("0.06%/0.09%")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [
                  _vm._v("0.05%/0.08%")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("0.04%/0.07%")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-column" }, [
                _c("div", { staticClass: "table-row header" }, [
                  _vm._v(_vm._s(_vm.$t("300023")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("5")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("10")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("50")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("100")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("500")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-column" }, [
                _c("div", { staticClass: "table-row header" }, [
                  _vm._v(_vm._s(_vm.$t("300024")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("60")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("60")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("60")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("60")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("60")]),
                _vm._v(" "),
                _c("div", { staticClass: "table-row" }, [_vm._v("60")])
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "tips left" }, [
              _vm._v(_vm._s(_vm.$t("300026")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "activity-detail" }, [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("300009")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "block" }, [
              _vm._v(_vm._s(_vm.$t("300010")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-2" }, [
              _c("div", { staticClass: "table-header flex-between" }, [
                _c("div", { staticClass: "th" }, [
                  _vm._v(_vm._s(_vm.$t("300017", { coin: "USDT" })))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [
                  _vm._v(_vm._s(_vm.$t("300018", { coin: "ET" })))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-body" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "tr flex-between" }, [
                  _c("div", { staticClass: "td" }, [_vm._v("≥ 100000")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "td" }, [
                    _vm._v("3000+VIP6 (" + _vm._s(_vm.$t("300019")) + ")")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tr flex-between" }, [
                  _c("div", { staticClass: "td" }, [_vm._v("≥ 200000")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "td" }, [
                    _vm._v("8000+VIP7 (" + _vm._s(_vm.$t("300019")) + ")")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tr flex-between" }, [
                  _c("div", { staticClass: "td" }, [_vm._v("≥ 500000")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "td" }, [
                    _vm._v("30000+VIP8 (" + _vm._s(_vm.$t("300019")) + ")")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "left" }, [
                _vm._v(_vm._s(_vm.$t("300020")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "activity-detail" }, [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("300011")))
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "left",
              domProps: { innerHTML: _vm._s(_vm.$t("300012")) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "share-button" }, [
            _c(
              "div",
              { staticClass: "button pointer", on: { click: _vm.handleShare } },
              [
                _c("i", { staticClass: "iconfont icon-fenxiang" }),
                _vm._v("\n          " + _vm._s(_vm.$t("300013")) + "\n        ")
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("300014")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("300015")))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "activity-footer" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("300016")))]),
            _vm._v(" "),
            _c("div", { staticClass: "links" }, [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: { slot: "image", "aria-hidden": "true" },
                  slot: "image"
                },
                [_c("use", { attrs: { "xlink:href": "#icon-xiaofeiji" } })]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v("https://t.me/SuperExOfficial\n            "),
                _c("i", {
                  staticClass: "copy iconfont icon-fuzhi",
                  attrs: {
                    "data-clipboard-text": "https://t.me/SuperExOfficial"
                  },
                  on: { click: _vm.handleCopy }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "links" }, [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: { slot: "image", "aria-hidden": "true" },
                  slot: "image"
                },
                [_c("use", { attrs: { "xlink:href": "#icon-tuite" } })]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v("https://twitter.com/SuperExet\n            "),
                _c("i", {
                  staticClass: "copy iconfont icon-fuzhi",
                  attrs: {
                    "data-clipboard-text": "https://twitter.com/SuperExet"
                  },
                  on: { click: _vm.handleCopy }
                })
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tr flex-between" }, [
      _c("div", { staticClass: "td" }, [_vm._v("≥ 500")]),
      _vm._v(" "),
      _c("div", { staticClass: "td" }, [_vm._v("5")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tr flex-between" }, [
      _c("div", { staticClass: "td" }, [_vm._v("≥ 1500")]),
      _vm._v(" "),
      _c("div", { staticClass: "td" }, [_vm._v("15")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tr flex-between" }, [
      _c("div", { staticClass: "td" }, [_vm._v("≥ 3000")]),
      _vm._v(" "),
      _c("div", { staticClass: "td" }, [_vm._v("50")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tr flex-between" }, [
      _c("div", { staticClass: "td" }, [_vm._v("≥ 5000")]),
      _vm._v(" "),
      _c("div", { staticClass: "td" }, [_vm._v("100")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tr flex-between" }, [
      _c("div", { staticClass: "td" }, [_vm._v("≥ 20000")]),
      _vm._v(" "),
      _c("div", { staticClass: "td" }, [_vm._v("500")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7dc7432", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7dc7432","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/newYearGifts.vue
// module id = Qfx4
// module chunks = 0